"use strict";

angular.module("customer")
.controller("UserPartnershipDetailsModal", function(
    $q, $scope, $attrs, $state, $stateParams, $timeout, close, gettextCatalog, FlashBag, UserService, UserCustomerService,
    UserPartnershipService, OrderConsolidationService, NoOrderNotificationService, SalesRepPartnershipTagService,
    ModalService, ORDER_DEADLINE_LATE_HOURS
) {
    var _this = this;
    $scope.partnershipId = $attrs.partnershipId;
    $scope.salesRepPartnershipTagService = SalesRepPartnershipTagService;

    var startOfDay = moment().startOf('day');

    this.getDisabledButtonReturnConsolidationHelpTipHtmlContent = function() {
        return gettextCatalog.getString("Only one return consolidation per day is allowed.");
    };

    UserService.isUserFetched().then(function onSuccess(user) {
        var deferred = $q.defer();
        if (user && !!user.global_dedicated_vendor_id) {
            OrderConsolidationService.getPartnerships().$promise.then(function onSuccess(data) {
                $scope.orderConsolidationPartnerships = data;
                deferred.resolve();
            }, deferred.reject);
        }
        else {
            deferred.resolve();
        }
        return deferred.promise;
    }).then(function onSuccess() {
        fetch();
    });

    function fetch() {
        UserPartnershipService.query({id: $scope.partnershipId}).$promise
        .then(function onSuccess(data) {
            $scope.userPartnership = data;
            if (
                $scope.orderConsolidationPartnerships
                && $scope.orderConsolidationPartnerships.length
                && $scope.userPartnership
            ) {
                if ($scope.userPartnership.is_order_consolidation_order_source) {
                    $scope.orderConsolidationPartnerships.some(function(partnership) {
                        if ($scope.userPartnership.id === partnership.partnership_id) {
                            $scope.userPartnership.distributorData = partnership;
                        }
                    });
                }
            }
        });
    }

    this.choose = function() {
        UserCustomerService.choose($scope.userPartnership.user_customer_id).$promise
        .then(function onSuccess() {
            var updateCurrentNumbers = true;
            UserService.refreshCurrentUser(updateCurrentNumbers).then(function() {
                _this.close();
                $state.go("home");
            });
        });
    };

    this.isOrderDeadLineSoonLate = function(deadlineDate) {
        if (!deadlineDate) {
            return false;
        }
        return moment(deadlineDate).isBetween(moment(), moment().add(ORDER_DEADLINE_LATE_HOURS, "hours"), undefined, '[)');
    };

    this.isOrderDeadLineLate = function(deadlineDate) {
        if (!deadlineDate) {
            return false;
        }
        return moment(deadlineDate).isBetween(startOfDay, moment(), undefined, '[)');
    };

    this.isOrderDeadLineWarning = function(deadlineDate) {
        if (!deadlineDate) {
            return false;
        }
        return this.isOrderDeadLineSoonLate(deadlineDate) || this.isOrderDeadLineLate(deadlineDate);
    };

    this.goToOrderConsolidation = function(sourcePartnership, orderItemType) {
        var params = {
            'order-item-type': orderItemType,
            'source': sourcePartnership.partnership_id,
        };
        UserCustomerService.choose(sourcePartnership.user_customer_id).$promise
        .then(function onSuccess() {
            UserService.refreshCurrentUser().then(function() {
                _this.close();
                $state.go("orderConsolidation", params);
            });
        });
    };

    this.goToReturnOrderConsolidation = function(sourcePartnership) {
        if (
            sourcePartnership.product_suppliers
            && sourcePartnership.product_suppliers.length === 1
            && sourcePartnership.product_suppliers[0].disable_return_consolidation
        ) {
            return;
        }

        this.goToOrderConsolidation(sourcePartnership, 'returns');
    };

    this.goToOrderListing = function() {
        UserCustomerService.choose($scope.userPartnership.user_customer_id).$promise
        .then(function onSuccess() {
            UserService.refreshCurrentUser().then(function() {
                _this.close();
                $state.go("myOrders");
            });
        });
    };

    this.goToInvoiceListing = function() {
        UserCustomerService.choose($scope.userPartnership.user_customer_id).$promise
        .then(function onSuccess() {
            UserService.refreshCurrentUser().then(function() {
                _this.close();
                $state.go("invoiceList");
            });
        });
    };

    this.openNoOrderNotificationConfirmation = function() {
        _this.close();
        // noinspection JSCheckFunctionSignatures,JSVoidFunctionReturnValueUsed
        ModalService.showModal({
            templateUrl: require("../../order/no-order-notification/modals/no-order-notification.modal.html"),
            controller: "NoOrderNotificationConfirmationController",
            controllerAs: "noOrderNotificationConfirmationCtrl",
            inputs: {
                $attrs: {
                    customerName: $scope.userPartnership.name,
                    deliveryDate: $scope.userPartnership.delivery_date,
                }
            }
        }).then(function(modal) {
            modal.element.modal({
                backdrop: "static",
                keyboard: false
            });
            modal.close.then(function(confirm) {
                if (!confirm) {
                    return;
                }

                NoOrderNotificationService.submitSalesRepEmptyOrder($scope.userPartnership.id).then(function onSuccess() {
                    $scope.$emit("queryListing");
                    var message = gettextCatalog.getString("The no-order notification was sent.");
                    FlashBag.success(message, true);
                });
            });
        });
    };

    this.close = function() {
        $scope.$element.modal("hide");
        $scope.$element.remove();
        close.apply(this, arguments);
    };
});



//////////////////
// WEBPACK FOOTER
// ./customer/sections/user-partnership/modals/user-partnership-details.modal.js
// module id = 946
// module chunks = 0